<template>
  <div class="gap-x-5 py-6">
    <Input v-model="search" :placeholder="placeholder" class="xl:col-start-1 xl:col-end-4" />
    <Select v-if="active_filters.industry" v-model="industry" placeholder="Industry" class="xl:col-start-4 xl:col-end-7"
      :options="industries" />
    <Select v-if="active_filters.country" v-model="country" placeholder="Country" class="xl:col-start-7 xl:col-end-10"
      :options="countries" />
    <Select v-if="active_filters.ugc_country" v-model="ugc_country" placeholder="Country"
      class="xl:col-start-7 xl:col-end-10" :options="ugc_countries" />
    <Select v-if="active_filters.type" v-model="type" placeholder="Type" class="xl:col-start-6 xl:col-end-8"
      :options="types" />
    <Select v-if="active_filters.format" v-model="format" placeholder="Format" class="xl:col-start-7 xl:col-end-9"
      :options="formats" />
    <Select v-if="active_filters.platform" v-model="platform" placeholder="Platform" class="xl:col-start-9 xl:col-end-11"
      :options="platforms" />
    <Select v-if="active_filters.objective" v-model="objective" placeholder="Objective"
      class="xl:col-start-10 xl:col-end-12" :options="objectives" />
    <Select v-if="active_filters.month" v-model="month" placeholder="Months" class="xl:col-start-11 xl:col-end-14"
      :options="previous_months" />
    <Select v-if="active_filters.gender" v-model="gender" placeholder="Gender" class="xl:col-start-10 xl:col-end-12"
      :options="genders" />
    <div class="col-start-1 col-end-3 pt-4 flex">
      <div v-for="(value, name) in {
        industry,
        type,
        objective,
        format,
        platform,
        country,
        ugc_country,
        month,
        gender,
      }" :key="`filter${value}`">
        <span class="filters__item" v-if="value" @click="removeFilterOption(name)">
          <Icon name="Check" class="check w-4 h-4 mr-2" />
          <Icon name="Close" class="close w-4 h-4 mr-2" />
          <p v-if="name == 'month'">
            {{
              value === "PREV_MONTH"
              ? "Previous months"
              : new Date(value).toLocaleString("en-us", {
                month: "long",
                year: "numeric",
              })
            }}
          </p>
          <p v-else>
            {{ value }}
          </p>
        </span>
      </div>
    </div>
  </div>
</template>

<script>
import debounce from "lodash.debounce";
import { computed, watch, ref } from "vue";
import { useStore } from "vuex";
import Input from "@/components/UI/Input";
import Select from "@/components/UI/Select/index";
import Icon from "@/components/UI/Icon";
import moment from "moment";
import { useRouter } from "vue-router";
export default {
  components: { Input, Select, Icon },
  props: {
    "default-filters": Object,
    active_filters: Object,
    origin: String,
    placeholder: {
      type: String,
      default: "Search Ad by keywords",
    },
  },
  setup(props) {
    const store = useStore();
    const router = useRouter();
    const textFilters = ref(true);

    const search = computed({
      get() {
        if (props["origin"] === "tiktoks") {
          return store.state.filters_tiktoks.search;
        } else if (props["origin"] === "topbrands") {
          return store.state.filters_topBrands.search;
        } else if (props["origin"] === "ugccreators") {
          return store.state.filters_ugcCreators.search;
        } else {
          return store.state.filters.search;
        }
      },
      set(newValue) {
        let setTitle;
        if (props["origin"] === "tiktoks") {
          setTitle = "SET_FILTERS_PROPERTY_TIKTOKS";
        } else if (props["origin"] === "topbrands") {
          setTitle = "SET_FILTERS_PROPERTY_TOP_BRANDS";
        } else if (props["origin"] === "ugccreators") {
          setTitle = "SET_FILTERS_PROPERTY_UGC_CREATORS";
        } else {
          setTitle = "SET_FILTERS_PROPERTY";
        }
        store.commit(setTitle, {
          key: "search",
          value: newValue,
        });
      },
    });

    const country = computed({
      get() {
        if (props["origin"] === "tiktoks") {
          return store.state.filters_tiktoks.country;
        } else if (props["origin"] === "topbrands") {
          return store.state.filters_topBrands.country;
        } else {
          return store.state.filters.country;
        }
      },
      set(newValue) {
        let setTitle;
        if (props["origin"] === "tiktoks") {
          setTitle = "SET_FILTERS_PROPERTY_TIKTOKS";
        } else if (props["origin"] === "topbrands") {
          setTitle = "SET_FILTERS_PROPERTY_TOP_BRANDS";
        } else {
          setTitle = "SET_FILTERS_PROPERTY";
        }
        store.commit(setTitle, {
          key: "country",
          value: newValue,
        });
      },
    });
    const ugc_country = computed({
      get() {
        return store.state.filters_ugcCreators.ugc_country;
      },
      set(newValue) {
        let setTitle;
        setTitle = "SET_FILTERS_PROPERTY_UGC_CREATORS";

        store.commit(setTitle, {
          key: "ugc_country",
          value: newValue,
        });
      },
    });
    const industry = computed({
      get() {
        if (props["origin"] === "tiktoks") {
          return store.state.filters_tiktoks.industry;
        } else if (props["origin"] === "topbrands") {
          return store.state.filters_topBrands.industry;
        } else if (props["origin"] === "ugccreators") {
          return store.state.filters_ugcCreators.industry;
        } else {
          return store.state.filters.industry;
        }
      },
      set(newValue) {
        let setTitle;
        if (props["origin"] === "tiktoks") {
          setTitle = "SET_FILTERS_PROPERTY_TIKTOKS";
        } else if (props["origin"] === "topbrands") {
          setTitle = "SET_FILTERS_PROPERTY_TOP_BRANDS";
        } else if (props["origin"] === "ugccreators") {
          setTitle = "SET_FILTERS_PROPERTY_UGC_CREATORS";
        } else {
          setTitle = "SET_FILTERS_PROPERTY";
        }
        store.commit(setTitle, {
          key: "industry",
          value: newValue,
        });
      },
    });

    const type = computed({
      get() {
        if (props["origin"] === "tiktoks") {
          return "";
        } else if (props["origin"] === "topbrands") {
          return "";
        } else {
          return store.state.filters.type;
        }
      },
      set(newValue) {
        store.commit("SET_FILTERS_PROPERTY", {
          key: "type",
          value: newValue,
        });
      },
    });
    const objective = computed({
      get() {
        if (props["origin"] === "tiktoks") {
          return "";
        } else if (props["origin"] === "topbrands") {
          return "";
        } else {
          return store.state.filters.objective;
        }
      },
      set(newValue) {
        store.commit("SET_FILTERS_PROPERTY", {
          key: "objective",
          value: newValue,
        });
      },
    });
    const gender = computed({
      get() {
        if (props["origin"] === "ugccreators") {
          return store.state.filters_ugcCreators.gender;
        } else {
          return "";
        }
      },
      set(newValue) {
        store.commit("SET_FILTERS_PROPERTY_UGC_CREATORS", {
          key: "gender",
          value: newValue,
        });
      },
    });

    const month = computed({
      get() {
        if (props["origin"] === "tiktoks") {
          return "";
        } else if (props["origin"] === "topbrands") {
          return "";
        } else {
          return store.state.filters.month;
        }
      },
      set(newValue) {
        store.commit("SET_FILTERS_PROPERTY", {
          key: "month",
          value: newValue,
        });
      },
    });

    const format = computed({
      get() {
        if (props["origin"] === "tiktoks") {
          return "";
        } else if (props["origin"] === "topbrands") {
          return "";
        } else {
          return store.state.filters.format;
        }
      },
      set(newValue) {
        store.commit("SET_FILTERS_PROPERTY", {
          key: "format",
          value: newValue,
        });
      },
    });

    const platform = computed({
      get() {
        if (props["origin"] === "tiktoks") {
          return "";
        } else if (props["origin"] === "topbrands") {
          return "";
        } else {
          return store.state.filters.platform;
        }
      },
      set(newValue) {
        store.commit("SET_FILTERS_PROPERTY", {
          key: "platform",
          value: newValue,
        });
      },
    });

    const exist_analysis = computed({
      get() {
        if (props["origin"] === "tiktoks") {
          return "";
        } else if (props["origin"] === "topbrands") {
          return "";
        } else {
          return store.state.filters.exist_analysis;
        }
      },
      set(newValue) {
        store.commit("SET_FILTERS_PROPERTY", {
          key: "exist_analysis",
          value: newValue,
        });
      },
    });

    const industries = computed(() => store.state.industries);
    const types = computed(() => store.state.types);
    const objectives = computed(() => store.state.objectives);
    const countries = computed(() => store.state.countries);
    const ugc_countries = computed(() => store.state.ugc_countries);
    const formats = computed(() => store.state.formats);
    const platforms = computed(() => store.state.platforms);
    const exists_analysis = computed(() => store.state.exists_analysis);
    const role = store.state.role;
    const genders = computed(() => store.state.genders);
    const user = computed(() => store.state.user);
    const collectionMonths = computed(() => store.state.collectionMonths);
    const PREV_MONTHS = (a) => {
      var dates = [];
      dates.push({
        value: new Date(),
        label: moment(new Date()).format("MMMM YYYY"),
      });
      for (let i = 0; i < a; i++) {
        var prev_month = new Date();

        prev_month.setMonth(prev_month.getMonth() - i, 0);

        dates.push({
          value: new Date(prev_month),
          label: moment(prev_month).format("MMMM YYYY"),
        });
      }
      dates.push({
        value: "PREV_MONTH",
        label: "Previous Months",
      });
      return dates;
    };

    const previous_months = PREV_MONTHS(2);

    watch(
      search,
      debounce(() => {
        getAdvertisements();
      }, 1500)
    );
    watch(month, () => {
      if (["monthly"].includes(role) && month.value == "PREV_MONTH") {
        console.log("1")

        router.push("/pricing");
      }
    });
    watch(
      [
        industry,
        type,
        objective,
        format,
        platform,
        exist_analysis,
        country,
        month,
        ugc_country,
        gender,
      ],
      () => {
        getAdvertisements();
      }
    );

    const getAdvertisements = async () => {
      if (props["default-filters"]) {
        await store.dispatch("GET_TOTAL_DISCOVER", {
          addedFilters: props["default-filters"],
        });
        store.dispatch("GET_ADVERTISEMENTS", {
          addedFilters: props["default-filters"],
        });
        store.dispatch("GET_TIKTOKS", {
          addedFilters: null,
          idUser: user.value.id,
        });
      } else {
        if (props["origin"] === "tiktoks") {
          store.commit("SET_PAGE_Tiktoks", 1);
          store.commit("SET_TIKTOKS", null);
          store.dispatch("GET_TIKTOKS", {
            addedFilters: null,
            idUser: user.value.id,
          });
        } else if (props["origin"] === "topbrands") {
          store.commit("SET_PAGE_TopBrands", 1);
          store.commit("SET_TOP_BRANDS", null);
          store.dispatch("GET_TOP_BRANDS", { addedFilters: null });
        } else if (props["origin"] === "ugccreators") {
          store.commit("SET_PAGE_TopBrands", 1);
          store.commit("SET_UGC_CREATORS", null);
          store.dispatch("GET_UGC_CREATORS", { addedFilters: null });
        } else {
          store.commit("SET_PAGE", 1);
          store.commit("SET_ADVERTISEMENTS", null);
          await store.dispatch("GET_TOTAL_DISCOVER", {
            addedFilters: props["default-filters"],
          });
          store.dispatch("GET_ADVERTISEMENTS", { addedFilters: null });
          store.dispatch("GET_TIKTOKS", {
            addedFilters: null,
            idUser: user.value.id,
          });
        }
        // store.dispatch("GET_ADVERTISEMENTS", { addedFilters: null });
      }
    };

    const resetFilters = () => {
      search.value = null;
      store.commit("CLEAN_FILTERS");
      store.commit("SET_PAGE", 1);
      store.commit("SET_ADVERTISEMENTS", null);
      if (props["default-filters"]) {
        store.dispatch("GET_ADVERTISEMENTS", {
          addedFilters: props["default-filters"],
        });
      } else {
        store.dispatch("GET_ADVERTISEMENTS", { addedFilters: null });
      }
    };

    const removeFilterOption = (name) => {
      switch (name) {
        case "industry":
          industry.value = null;
          break;
        case "country":
          country.value = null;
          break;
        case "type":
          type.value = null;
          break;
        case "objective":
          objective.value = null;
          break;
        case "month":
          month.value = null;
          break;
        case "format":
          format.value = null;
          break;
        case "platform":
          platform.value = null;
          break;
        case "exist_analysis":
          exist_analysis.value = null;
          break;
        case "ugc_country":
          ugc_country.value = null;
          break;
        case "gender":
          gender.value = null;
          break;
        default:
          break;
      }
    };

    const toggleMoreFilters = () => {
      textFilters.value = !textFilters.value;
    };

    return {
      toggleMoreFilters,
      textFilters,
      search,
      industry,
      type,
      objective,
      month,
      country,
      ugc_country,
      format,
      platform,
      exist_analysis,
      industries,
      types,
      objectives,
      countries,
      ugc_countries,
      formats,
      platforms,
      exists_analysis,
      getAdvertisements,
      resetFilters,
      removeFilterOption,
      role,
      user,
      gender,
      genders,
      collectionMonths,
      previous_months,
    };
  },
};
</script>

<style scoped>
.filters__item {
  @apply flex border-r border-gray-600 py-0 px-3 mr-2 cursor-pointer;
}

.filters__item svg {
  transition: 0.3s;
}

.filters__item:hover .check,
.filters__item .close {
  display: none;
}

.filters__item:hover .close {
  display: block;
}

.filters__item:hover .refresh {
  transform: rotate(60deg);
}

.premium {
  transition: all 0.3s;
  @apply scale-100 cursor-pointer border-2 border-indigo-500 rounded-lg px-6 pt-4 pb-2 mb-12 relative text-base;
}

.premium:hover {
  @apply transform scale-95;
}

.premium * {
  @apply pointer-events-none;
}
</style>
